export const mapResourceLightItem = (item = {}, propList = ['name']) => {
  const mappedItem = {
    id: parseInt(item.id),
  }
  for (const prop of propList) {
    mappedItem[prop] = item?.attributes?.[prop] || item?.[prop] || null
  }
  return mappedItem
}
